module.exports = __webpack_public_path__ + "img/rk_zy.e5380591.png";